/*
 * PDE - JavaScript
 * Copyright 2010. All rights reserved.
 *
 * Class: Apos
 * Description: Provides classes instance methods that fixes absolutely positioned elements.
 */
var Apos = new Class
({
	_hook: null,				 // Internal element to based positioning off.
	_obj: null,					// Absolutely positioned element or a function reference.
	setHook: function(element)
	{
		if(typeOf(element) == 'element')
		{
			this._hook = element;
		}
	},
	setApos: function(obj, offset)
	{
		this._obj = obj;
		this.offset = [offset, {x: 0, y: 0}].pick();
		window.addEvent('resize', function(e)
		{
			this.aposStart();
		}.bind(this));
	},
	aposStart: function()
	{
		var coor, offset = this.offset;
		if (this._hook)
		{
			coor = this._hook.getCoordinates();
			switch (typeOf(this._obj))
			{
				case 'function':
					 this._obj(coor);
				break;
				case 'element':
					this._obj.setStyles(
					{
						top: coor.top+offset.y,
						left: coor.left+offset.x
					});
				break;
			}
		}
	}
});